angular.module('filters').filter('waiverType', ["$filter", function($filter) {
  return function(type) {
    if (type === 'non_attending_contact') {
      return 'Not attending';
    } else {
      return $filter('humanize')(type);
    }
  };
}]);
